import { root } from './historical';

export const historical = {
  ...root,
};
